import { DEFAULT_PAGINATOR } from "../constants/api";
import ItemPriceService from "../services/item-price-service";

const RESET_ALL = "itemPrice/RESET_ALL";
const GET_ALL = "itemPrice/GET_ALL";
const RESET_DROPDOWN = "itemPrice/RESET_DROPDOWN";
const GET_ALL_DROPDOWN = "itemPrice/GET_ALL_DROPDOWN";
const GET_BY_ID = "itemPrice/GET_BY_ID";
const UPDATE = "itemPrice/UPDATE";
const DELETE = "itemPrice/DELETE";

const initalState = {
  list: {
    data: [],
    paginator: DEFAULT_PAGINATOR,
  },
  detail: null,
  dropdown: {
    data: [],
    paginator: DEFAULT_PAGINATOR,
  }
};

const itemPrice = (state = { ...initalState }, { type, payload }) => {
  let findIdx = -1
  switch (type) {
    case RESET_ALL:
      return initalState
    case GET_ALL:
      return {
        ...state,
        list: {
          data: payload.data,
          paginator: payload.paginator
        },
      };
    case GET_ALL_DROPDOWN:
      return {
        ...state,
        dropdown: {
          data: [...state.dropdown.data, ...payload.data],
          paginator: payload.paginator
        },
      };
    case GET_BY_ID:
      return {
        ...state,
        detail: payload.data
      };
    case RESET_DROPDOWN:
      return {
        ...state,
        dropdown: {
          data: [],
          paginator: DEFAULT_PAGINATOR
        }
      };
    case UPDATE:
      if (state.detail && state.detail.id === payload.data.id) {
        state.detail = {
          ...state.detail,
          ...payload.data,
        }
      }
      findIdx = state.list.data.findIndex(d => d.id === payload.data.id)
      if (findIdx > -1) {
        state.list.data[findIdx] = {
          ...state.list.data[findIdx],
          ...payload.data
        }
      }
      findIdx = state.dropdown.data.findIndex(d => d.id === payload.data.id)
      if (findIdx > -1) {
        state.dropdown.data[findIdx] = {
          ...state.dropdown.data[findIdx],
          ...payload.data
        }
      }
      return {
        ...state,
      };
    case DELETE:
      if (state.detail && state.detail.id === payload.data.id) {
        state.detail = null
      }
      findIdx = state.list.data.findIndex(d => d.id === payload.data.id)
      if (findIdx > -1) {
        state.list.data.splice(findIdx, 1)
        state.list.paginator = {
          ...state.list.paginator,
          totalItemPrices: state.list.paginator.totalItemPrices - 1,
          itemPriceTo: state.list.paginator.itemPriceTo - 1,
        }
      }
      findIdx = state.dropdown.data.findIndex(d => d.id === payload.data.id)
      if (findIdx > -1) {
        state.dropdown.data.splice(findIdx, 1)
        state.dropdown.paginator = {
          ...state.dropdown.paginator,
          totalItemPrices: state.dropdown.paginator.totalItemPrices - 1,
          itemPriceTo: state.dropdown.paginator.itemPriceTo - 1,
        }
      }
      return {
        ...state,
      };
    default:
      return state;
  }
};
export default itemPrice;

export const getAll = (itemId, params, isDropdown = false) => async (dispatch) => {
  const resp = await ItemPriceService.getAll(itemId, params);
  if (resp.status && resp.status === 200) {
    if (isDropdown) {
      dispatch({ type: GET_ALL_DROPDOWN, payload: resp.data });
    } else {
      dispatch({ type: GET_ALL, payload: resp.data });
    }
  }
  return resp
};

export const getByIdDropdown = async (itemId, id) => {
  const resp = await ItemPriceService.getById(itemId, id);
  if (resp.status && resp.status === 200) {
    return resp.data.data
  }
  return null
};

export const getById = (itemId, id) => async (dispatch) => {
  const resp = await ItemPriceService.getById(itemId, id);
  if (resp.status && resp.status === 200) {
    dispatch({ type: GET_BY_ID, payload: resp.data });
  }
  return resp
};

export const resetDropdown = () => async (dispatch) => {
  dispatch({ type: RESET_DROPDOWN });
};

export const resetAll = () => async (dispatch) => {
  dispatch({ type: RESET_ALL });
};

export const updateById = (itemId, id, params) => async (dispatch) => {
  const resp = await ItemPriceService.updateById(itemId, id, params);
  if (resp.status && resp.status === 200) {
    dispatch({ type: UPDATE, payload: resp.data });
  }
  return resp
};

export const create = (itemId, params) => {
  return ItemPriceService.create(itemId, params);
};

export const deleteById = (itemId, id) => async (dispatch) => {
  const resp = await ItemPriceService.deleteById(itemId, id);
  if (resp.status && resp.status === 200) {
    dispatch({ type: DELETE, payload: resp.data });
  }
  return resp
};
